import { checksService } from '@/services/checks.service'

export function getActionLoadCheckss() {
  return {
    type: 'loadCheckss',
  }
}

export function getActionRemoveChecks(taskId) {
  return {
    type: 'removeChecks',
    taskId,
  }
}
export function getActionSaveChecks(checks) {
  return {
    type: 'saveChecks',
    checks,
  }
}

export const checksStore = {
  state: {
    checks: [],
    initiallyCommitted: false,
    batchId: null,
  },
  getters: {
    checks({ checks }) {
      return checks
    },
    isInitiallyCommitted({ initiallyCommitted }) {
      return initiallyCommitted
    },
    getChecksById: (state) => (id) => {
      return state.checks.find((check) => check.ID === id)
    },
  },
  mutations: {
    setChecks(state, { checks }) {
      state.checks = checks
      if (!state.initiallyCommitted) {
        state.initiallyCommitted = true
      }
    },
    setInitiallyCommitted(state, { committed }) {
      state.initiallyCommitted = committed
    },
    setBetchId(state, { batchId }) {
      state.batchId = batchId
    },
    saveChecks(state, { checks }) {
      const idx = state.checks.findIndex(
        (currChecks) => currChecks.ID === checks.ID
      )
      if (idx !== -1) state.checks.splice(idx, 1, checks)
      else state.checks.push(checks)
    },
    updateSingleCheck(state, { updatedCheck }) {
      const checkIndex = state.checks.findIndex((check) =>
        check.checks.some((c) => c.CheckGuid === updatedCheck.CheckGuid)
      )

      if (checkIndex !== -1) {
        const innerCheckIndex = state.checks[checkIndex].checks.findIndex(
          (c) => c.CheckGuid === updatedCheck.CheckGuid
        )

        if (innerCheckIndex !== -1) {
          // Update the specific check
          state.checks[checkIndex].checks.splice(
            innerCheckIndex,
            1,
            updatedCheck
          )
        }
      }
    },

    removeChecksGroup(state, { ChecksHeaderGuid }) {
      state.checks = state.checks.filter(
        (checks) => checks.ChecksHeaderGuid !== ChecksHeaderGuid
      )
    },
  },
  actions: {
    async loadChecks({ commit, state }, { contactGuid }) {
      try {
        let checks = await checksService.getChecksToFill(
          contactGuid
        )

        let batchId = checks[0].BatchId
        checks = checks.map((item) => {
          return {
            ...item,
            NumbersOfPayments: 1,
            //add a array of checks whit the first check
            checks: [
              checksService.getEmptyCheck(
                item.ID,
                item.Amount,
                item.CreateDate
              ),
            ],
          }
        })
        commit({ type: 'setBetchId', batchId })
        commit({ type: 'setChecks', checks })
      } catch (err) {
        console.log('🚀 ~ loadChecks ~ err:', err)
        throw err
      }
    },
    async saveChecks({ commit }, { checks }) {
      try {
        // const newChecks = await taskService.save(checks)
        commit(getActionSaveChecks(checks))
      } catch (err) {
        console.log('🚀 ~ saveChecks ~ err:', err)
        throw err
      }
    },
    async getCheckByGuid({ state }, { CheckGuid }) {
      try {
        for (const check of state.checks) {
          const foundCheck = check.checks.find((c) => c.CheckGuid === CheckGuid)
          if (foundCheck) {
            return foundCheck
          }
        }
        return null
      } catch (err) {
        console.log('🚀 ~ getCheckByGuid ~ err:', err)
        throw err
      }
    },
    async submitChecksGroup({ commit }, { checksGroup }) {
      try {
        await checksService.submitChecksGroup(checksGroup)
        commit({
          type: 'removeChecksGroup',
          ChecksHeaderGuid: checksGroup.ChecksHeaderGuid,
        })
      } catch (err) {
        console.log('🚀 ~ submitChecksGroup ~ err:', err)
        throw err
      }
    },
    async updateCheck({ commit }, { check }) {
      commit({ type: 'updateSingleCheck', updatedCheck: check })
    },
    // async removeChecks({ commit }, { taskId }) {
    //     try {
    //         await taskService.remove(taskId)
    //         commit(getActionRemoveChecks(taskId))
    //     } catch (err) {
    //         logger.error('taskStore: Error in removeChecks', err)
    //         throw err
    //     }
    // },
  },
}
